import { defineComponent as _defineComponent } from 'vue'
import { Permission, ScriptGetAllParams, ScriptModel } from '@/types';
import { CodeIcon } from '@heroicons/vue/solid';
import { onMounted, ref } from 'vue';
import ScriptListItem from './components/ScriptListItem.vue';
import { useFilterStore, useUiStore } from '@/stores';
import { toast, toastServiceError } from '@/services';
import ScriptService from '@/services/api/ScriptService';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScriptPage',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const scripts = ref<ScriptModel[]>([]);

const fetchAllScripts = async () => {
    try {
        setLoading(true);
        const { data } = await ScriptService.getAll<ScriptModel[]>();
        scripts.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const updateScriptStatus = async (script: ScriptModel, isActive: boolean) => {
    try {
        setLoading(true);
        const { data } = await (isActive
            ? ScriptService.activate(script.id)
            : ScriptService.inactivate(script.id));
        toast.success(data.message);
        await fetchAllScripts();
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const handleActivateClick = (script: ScriptModel) => updateScriptStatus(script, true);
const handleInactivateClick = (script: ScriptModel) => updateScriptStatus(script, false);

onMounted(() => {
    if (route.query.clearStateOnSetup) {
        router.replace({ query: {} });
    }

    fetchAllScripts();
});

const __returned__ = { route, router, uiStore, setLoading, scripts, fetchAllScripts, updateScriptStatus, handleActivateClick, handleInactivateClick, get Permission() { return Permission }, get CodeIcon() { return CodeIcon }, ScriptListItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})